import RequiresAuth from '@website/components/auth/RequiresAuth';
import GuestBookingDetails from '@website/components/me/bookings/GuestBookingDetails';
import { useRouter } from 'next/router';

/**
 *
 * GuestDashboardIndividualBookingPage
 *
 * This is the page where guests will be able to see the booking details and
 * update their guest form
 *
 */

export default function GuestDashboardIndividualBookingPage() {
  const { query } = useRouter();

  const { spaceID } = query;

  return (
    <RequiresAuth>
      <GuestBookingDetails spaceID={spaceID as string} />
    </RequiresAuth>
  );
}
